import { Col, DesignTokens, Row } from "melco-ui";
import { ProductionFilesCard } from "./ProductionFilesCard";
import { StatisticsCardRowProps } from "./StatisticsCardRow";

const { spacings } = DesignTokens;

export const StatisticsCardRowAPIService: React.FC<StatisticsCardRowProps> = ({
  startTimestamp,
  endTimestamp,
}) => (
  <Row gutter={[spacings.middle, spacings.middle]}>
    <Col span={24}>
      <ProductionFilesCard
        startTimestamp={startTimestamp}
        endTimestamp={endTimestamp}
      />
    </Col>
  </Row>
);
